<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong class="black--text">Property types you work on:</strong>
      </div>

      <PropertyTypesDialog :pro="pro"/>
    </template>

    <div style="line-height: 1.2;">
      You will only receive leads for the property types shown.
    </div>
      
    <div class="d-flex flex-wrap mt-2" style="column-gap: 4px;">
      <v-chip
        v-if="!pro.excluded_structure_types.includes('traditional')"
        x-small
        color="grey lighten-3" 
        class="px-2"
        style="border: 1px solid #C0C0C0 !important"
      >
        Residential Homes
      </v-chip>

      <v-chip
        v-if="!pro.excluded_structure_types.includes('mobile_home')"
        x-small
        color="grey lighten-3" 
        class="px-2"
        style="border: 1px solid #C0C0C0 !important"
      >
        Mobile Homes
      </v-chip>

      <v-chip
        v-if="!pro.excluded_structure_types.includes('rv')"
        x-small
        color="grey lighten-3" 
        class="px-2"
        style="border: 1px solid #C0C0C0 !important"
      >
        RV's
      </v-chip>
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import PropertyTypesDialog from './PropertyTypesDialog'

  export default {
    name: 'YouPropertyTypes',

    props: ['pro'],

    components: { Section, PropertyTypesDialog }, 
  }
</script>
